import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../components/header.component';
import { Footer } from '../components/footer.component';
import SectionHeader from '../components/common';
import SEOMetadataComponent from '../components/seo-metadata.component';
import FreelancerCtaSection from '../components/freelancer-call-to-action';
import PrivacyPolicyComponent from '../components/privacy-policy.component';
import { LOCALES } from '../../common/constants';
import { InvozioAsFreelancer } from '../components/images/png/icons';

const PrivacyPolicyPage: React.FC = () => {
    const { t, i18n } = useTranslation();

    const currentLanguage = i18n.language;
    const isEnglish = currentLanguage === 'en' || currentLanguage === LOCALES.EN_US;
    const canonicalUrl = isEnglish
        ? `https://www.invozio.com/cookies?lang=${LOCALES.EN_US}`
        : `https://www.invozio.com/cookies?lang=${LOCALES.SV_SE}`;

    return (
        <>
            <Header />
            <SEOMetadataComponent
                title={t('PRIVACY_POLICY_TITLE')}
                description={t('PRIVACY_POLICY_DESCRIPTION')}
                canonicalUrl={canonicalUrl}
                noindex={false}
                robots="index, follow"
            />

            <SectionHeader
                titleKey={t('PRIVACY_POLICY_TITLE')}
                subtitleKey={t('PRIVACY_POLICY_DESCRIPTION')}
                 className="invozio-news-section"
                titleClassName="main-title"
                subtitleClassName="sub-title"
                alignment="center"
            /> 

            <PrivacyPolicyComponent />
            <div className="bg-footer">
                <Footer />
            </div>
        </>
    );
};

export default PrivacyPolicyPage;
